import script from "./GLApp.vue?vue&type=script&setup=true&lang=js"
export * from "./GLApp.vue?vue&type=script&setup=true&lang=js"

import "./GLApp.vue?vue&type=style&index=0&id=48981241&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48981241"]])

export default __exports__